var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useXFlowApp, createComponentModel, DisposableCollection } from '@antv/xflow';
import React from 'react';
export var useToolbarModel = function (props) {
    var config = props.config;
    var modelId = config.moduleId;
    var app = useXFlowApp();
    var _a = createComponentModel({
        name: modelId,
        layout: props.layout,
        mainGroups: [],
        extraGroups: [],
        customRender: null,
    }), state = _a[0], setState = _a[1], toolbarModel = _a[2], isModelReady = _a[3];
    /** 注册全局的model */
    React.useEffect(function () {
        var toDispose = new DisposableCollection();
        var deferredModel = app.modelService.findDeferredModel(modelId);
        if (!deferredModel) {
            var _a = config.getConfig(), toolbarCustomRender_1 = _a.toolbarCustomRender, toolbarModelService_1 = _a.toolbarModelService;
            var d = app.modelService.registerModel({
                id: modelId,
                modelFactory: function () { return toolbarModel; },
                watchChange: function (self) { return __awaiter(void 0, void 0, void 0, function () {
                    var updateCustomRender;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!toolbarModelService_1) return [3 /*break*/, 2];
                                return [4 /*yield*/, toolbarModelService_1(self, app.modelService, toDispose)];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!toolbarCustomRender_1) return [3 /*break*/, 4];
                                updateCustomRender = function (customRender) {
                                    self.setValue(function (m) { return (m.customRender = customRender); });
                                };
                                return [4 /*yield*/, toolbarCustomRender_1(app.modelService, updateCustomRender)];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4: return [2 /*return*/, toDispose];
                        }
                    });
                }); },
            });
            toDispose.push(d);
        }
        return function () {
            toDispose.dispose();
        };
        /* eslint-disable-next-line  */
    }, []);
    return { isModelReady: isModelReady, state: state, setState: setState, toolbarModel: toolbarModel };
};
